import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true
});

// Add auth token to every request EXCEPT auth/session (login exchange)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token && !config.url?.includes("/auth/session")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Clear stale token on 401 (except during login)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes("/auth/session")) {
      localStorage.removeItem("session_token");
    }
    return Promise.reject(error);
  }
);

export { api, BACKEND_URL, API };
